import { DesktopDatePicker, MobileDatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import utc from "dayjs/plugin/utc";
import { useField } from "formik";
import React from "react";

import __ from "../Translations";

interface DatepickerFormikMUIProps {
  label?: string;
  placeholder?: string;
  name: string;
  minDate?: Date | null;
  maxDate?: Date | null;
  disabled?: boolean;
  dataT1?: string;
  isMobile?: boolean;
  sx?: any;
}

dayjs.extend(utc); // Enable UTC support

const DatepickerFormikMUI: React.FC<DatepickerFormikMUIProps> = ({
  label = "",
  placeholder = "Data",
  name,
  minDate = null,
  maxDate = null,
  disabled = false,
  dataT1 = "date_picker_formik",
  isMobile = false,
  sx = {},
}) => {
  const [field, meta, helpers] = useField(name);
  const isError = Boolean(meta.touched && meta.error);
  const { setValue } = helpers;

  const rawValue = field.value;

  const currentValue =
    typeof rawValue === "number" && Number.isFinite(rawValue)
      ? dayjs.utc(rawValue)
      : null;

  const handleChange = (newValue: Dayjs | null) => {
    if (newValue && newValue.isValid()) {
      let clamped = newValue;
      if (maxDate && clamped.isAfter(dayjs(maxDate), "day")) {
        clamped = dayjs(maxDate);
      }
      if (minDate && clamped.isBefore(dayjs(minDate), "day")) {
        clamped = dayjs(minDate);
      }
      const utcMidnightTimestamp = Date.UTC(
        clamped.year(),
        clamped.month(),
        clamped.date()
      );
      setValue(utcMidnightTimestamp);
    } else {
      setValue(null);
    }
  };

  const PickerComponent = isMobile ? MobileDatePicker : DesktopDatePicker;

  return (
    <PickerComponent
      label={label}
      value={currentValue}
      onChange={handleChange}
      disabled={disabled}
      sx={sx}
      minDate={minDate ? dayjs(minDate) : undefined}
      maxDate={maxDate ? dayjs(maxDate) : undefined}
      localeText={{ toolbarTitle: __("Data urodzenia") }}
      slotProps={{
        textField: {
          fullWidth: true,
          error: isError,
          helperText: isError ? meta.error : "",
          placeholder,
          name,
          inputProps: { "data-t1": dataT1 },
          InputLabelProps: { shrink: true },
        },
        toolbar: {
          sx: { "& .MuiPickersToolbarText-root": { fontWeight: 800 } },
        },
      }}
    />
  );
};

export default DatepickerFormikMUI;
